// extracted by mini-css-extract-plugin
export default {"login":"loginComponent_login__ApedE","login__linkIcon":"loginComponent_login__linkIcon__n27gA"};